import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b24df0be&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b24df0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24df0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b24df0be')) {
      api.createRecord('b24df0be', component.options)
    } else {
      api.reload('b24df0be', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b24df0be&scoped=true&", function () {
      api.rerender('b24df0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Tfvs1fRTZdVR/JS/comp/SearchFilterTokens.vue"
export default component.exports